import { fetchInventoryAdjustments, selectInventoryAdjustment, resetCurrentInventoryAdjustment, fetchInventoryAdjustmentsDetail } from '../../actions/inventoryAdjustments_actions';
import { connect } from 'react-redux';
import { resetCurrentInventoryConvert } from '../../actions/inventoryConverts_actions';

import InventoryAdjustments from '../../components/Inventories/inventoryAdjustments'

function mapStateToProps(state) {
    return {
        inventoryAdjustments: state.inventoryAdjustments.all,
        isLoading: state.inventoryAdjustments.isLoading,
        error: state.inventoryAdjustments.error,
        currentInventoryAdjustment: state.inventoryAdjustments.currentInventoryAdjustment,
        userPermissions: state.auth.userPermissions,
        adjustmentDetail: state.inventoryAdjustments.adjustmentDetail, 
        adjustmentDetailError: state.inventoryAdjustments.adjustmentDetailError,
        adjustmentDetailIsLoading: state.inventoryAdjustments.adjustmentDetailIsLoading,
    };
}

export default connect(mapStateToProps, { resetCurrentInventoryConvert, fetchInventoryAdjustments, selectInventoryAdjustment, resetCurrentInventoryAdjustment, fetchInventoryAdjustmentsDetail })(InventoryAdjustments);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryAdjustments.jsx